"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _VerificationRequiredContainer = _interopRequireDefault(require("../../VerificationRequired/VerificationRequiredContainer"));
var _sendReceiveComponent = require("../../../propTypes/sendReceiveComponent");
var _ReceiveFormContainer = _interopRequireDefault(require("../ReceiveForm/ReceiveFormContainer"));
var _ReceiveAddressContainer = _interopRequireDefault(require("../ReceiveAddress/ReceiveAddressContainer"));
require("./Receive.css");
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('receive');
var ReceiveComponent = /*#__PURE__*/function (_React$Component) {
  function ReceiveComponent() {
    _classCallCheck(this, ReceiveComponent);
    return _callSuper(this, ReceiveComponent, arguments);
  }
  _inherits(ReceiveComponent, _React$Component);
  return _createClass(ReceiveComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        product = _this$props.product,
        useExternalAddress = _this$props.useExternalAddress,
        toggleUseExternalAddress = _this$props.toggleUseExternalAddress,
        onChange = _this$props.onChange,
        onSubmit = _this$props.onSubmit,
        disableDeposit = _this$props.disableDeposit,
        showDepositLimitWarningMessage = _this$props.showDepositLimitWarningMessage,
        verificationOnClick = _this$props.verificationOnClick,
        allowTransfer = _this$props.allowTransfer;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses()
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: bemClasses('source')
      }, allowTransfer && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item-with-border')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item', {
          active: !useExternalAddress
        }),
        onClick: function onClick() {
          useExternalAddress && toggleUseExternalAddress();
        }
      }, t("Friend"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item', {
          active: useExternalAddress
        }),
        onClick: function onClick() {
          !useExternalAddress && toggleUseExternalAddress();
        }
      }, t("External Wallet"))), /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('body')
      }, disableDeposit ? /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
        disabled: disableDeposit,
        onClick: verificationOnClick
      }) : showDepositLimitWarningMessage ? /*#__PURE__*/_react["default"].createElement("div", null, _config["default"].Deposit.verificationLevelDepositsDisabledMessage) : useExternalAddress ? /*#__PURE__*/_react["default"].createElement(_ReceiveAddressContainer["default"], {
        product: product
      }) : /*#__PURE__*/_react["default"].createElement(_ReceiveFormContainer["default"], {
        product: product,
        onChange: onChange,
        onSubmit: onSubmit
      })));
    }
  }]);
}(_react["default"].Component);
ReceiveComponent.propTypes = {
  product: _sendReceiveComponent.product,
  useExternalAddress: _propTypes["default"].bool.isRequired,
  toggleUseExternalAddress: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  allowTransfer: _propTypes["default"].bool.isRequired,
  VerificationRequiredComponent: _propTypes["default"].element,
  disableDeposit: _propTypes["default"].bool,
  showDepositLimitWarningMessage: _propTypes["default"].bool,
  verificationOnClick: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("send")(ReceiveComponent);